import styled from 'styled-components';

export const SchedulesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  overflow-y: auto;
  padding: 1rem;
  height: 70vh;
  max-height: 70vh;
  width: 30vw;

  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

export const ScheduleCard = styled.div`
  background: #eef5fc;
  border: 1px solid #d0e3f5;
  border-radius: 12px;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
  flex-shrink: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  
  &:hover {
    box-shadow: 0 4px 12px rgba(27, 114, 214, 0.12);
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.75rem;

    .date-title {
      font-size: 1.3rem;
      font-weight: 700;
      color: #1a569d;
    }
  }

  .service-title {
    font-size: 0.95rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 0.75rem;
    text-transform: uppercase;
  }

  .info-section {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-bottom: 1rem;
  }
`;

export const Tag = styled.span`
  background: #d6e8fa;
  color: #1a569d;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  text-transform: uppercase;
`;

export const BadgeRow = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;

  .badge {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    background: transparent;
    border: 1px solid #a3c8ed;
    color: #1a569d;
    font-size: 0.8rem;
    font-weight: 700;
    padding: 0.35rem 0.6rem;
    border-radius: 6px;
    text-transform: uppercase;
    
    svg {
      font-size: 0.9rem;
    }
  }
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  color: #666;
  font-weight: 500;

  .icon {
    font-size: 0.9rem;
    color: #888;
  }

  &.online-info {
    color: #1a569d;
    font-weight: 600;
    margin-top: 0.2rem;
    
    .icon {
      color: #1a569d;
    }
  }
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  background: #1b72d6;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.75rem;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #155bb0;
  }

  svg {
    font-size: 1.1rem;
  }
`;